import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [showRefundPolicy, setShowRefundPolicy] = useState(false);
  // Close on Escape key + lock body scroll while open
  useEffect(() => {
    if (!showRefundPolicy) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setShowRefundPolicy(false);
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [showRefundPolicy]);
  return <>
      <footer className="bg-deep-black text-gray-500 py-12 border-t border-white/10 text-center font-inter text-sm" data-id="element-74">
        <div className="max-w-6xl mx-auto px-6" data-id="element-75">
          <p className="mb-4" data-id="element-76">
            © {new Date().getFullYear()} Diosa Letal. Todos los derechos
            reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-77">
            <a href="#" className="hover:text-white transition-colors" data-id="element-78">
              Términos y Condiciones
            </a>
            <button type="button" onClick={() => setShowRefundPolicy(true)} className="hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-79">
              Política de Devolución
            </button>
            <a href="#" className="hover:text-white transition-colors" data-id="element-80">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-81">
              Contacto
            </a>
          </div>
          <p className="mt-8 text-xs opacity-50 max-w-2xl mx-auto" data-id="element-82">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-83">
        {showRefundPolicy && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-black/70 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={() => setShowRefundPolicy(false)} role="dialog" aria-modal="true" aria-labelledby="refund-policy-title" data-id="element-84">
            <motion.div className="relative bg-white text-deep-black w-full max-w-2xl max-h-[88vh] rounded-sm shadow-2xl flex flex-col" initial={{
          opacity: 0,
          y: 20,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.98
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} data-id="element-85">
              {/* Header */}
              <div className="flex items-start justify-between gap-4 px-6 sm:px-8 py-5 border-b border-gray-200" data-id="element-86">
                <h2 id="refund-policy-title" className="text-xl sm:text-2xl font-playfair text-deep-black" data-id="element-87">
                  Política de Reembolsos
                </h2>
                <button type="button" onClick={() => setShowRefundPolicy(false)} aria-label="Cerrar" className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-gray-500 hover:text-deep-black hover:bg-gray-100 transition-colors" data-id="element-88">
                  <X className="w-5 h-5" data-id="element-89" />
                </button>
              </div>

              {/* Scrollable body */}
              <div className="overflow-y-auto px-6 sm:px-8 py-6 font-inter text-sm sm:text-[15px] leading-relaxed text-gray-700 space-y-5" data-id="element-90">
                <div data-id="element-91">
                  <h3 className="font-playfair text-lg text-deep-black mb-2" data-id="element-92">
                    Política de Reembolsos y Devoluciones — Diosa Letal
                  </h3>
                  <p data-id="element-93">
                    Debido a la naturaleza digital de nuestros productos, todas
                    las ventas del eBook{' '}
                    <strong className="font-semibold text-deep-black" data-id="element-94">
                      "Diosa Letal"
                    </strong>{' '}
                    y sus bonos son finales.
                  </p>
                  <p className="mt-3" data-id="element-95">
                    Una vez completada la compra, recibirás acceso al contenido
                    digital adquirido, por lo que no podemos ofrecer
                    devoluciones, cambios o cancelaciones por arrepentimiento de
                    compra, falta de uso del producto o interpretación personal
                    del contenido.
                  </p>
                  <p className="mt-3" data-id="element-96">
                    Te recomendamos revisar cuidadosamente todos los detalles
                    del producto antes de realizar la compra, para asegurarte de
                    que se ajusta a tus necesidades y expectativas.
                  </p>
                  <p className="mt-3" data-id="element-97">
                    Si tenés algún problema para acceder, descargar o visualizar
                    tu eBook, meditaciones, ejercicios o bonos incluidos, podés
                    contactarnos a:{' '}
                    <a href="mailto:adonisclubstore@gmail.com" className="text-bordeaux font-semibold underline underline-offset-2" data-id="element-98">
                      adonisclubstore@gmail.com
                    </a>
                  </p>
                  <p className="mt-3" data-id="element-99">
                    Nuestro equipo te ayudará para que puedas recibir
                    correctamente todo el material adquirido.
                  </p>
                </div>

                <div data-id="element-100">
                  <h3 className="font-playfair text-lg text-deep-black mb-2" data-id="element-101">
                    Condiciones de Garantía de Reembolso
                  </h3>
                  <p data-id="element-102">
                    En Diosa Letal, confiamos en la calidad del contenido,
                    ejercicios y recursos que ofrecemos. Por eso, en caso de que
                    un producto específico incluya una{' '}
                    <strong className="font-semibold text-deep-black" data-id="element-103">
                      Garantía de Devolución de 30 días
                    </strong>
                    , esta estará sujeta a las siguientes condiciones.
                  </p>
                  <p className="mt-3" data-id="element-104">
                    Al comprar, aceptás los siguientes términos:
                  </p>
                </div>

                <div data-id="element-105">
                  <h4 className="font-semibold text-deep-black mb-2" data-id="element-106">
                    Elegibilidad
                  </h4>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-107">
                    <li data-id="element-108">
                      Los reembolsos solo estarán disponibles dentro de los{' '}
                      <strong className="font-semibold text-deep-black" data-id="element-109">
                        30 días corridos
                      </strong>{' '}
                      posteriores a la fecha de compra.
                    </li>
                    <li data-id="element-110">
                      Para solicitar un reembolso, deberás demostrar que
                      realmente consumiste, trabajaste y aplicaste el material
                      del producto. Esto puede incluir:
                      <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-111">
                        <li data-id="element-112">
                          Capturas, notas o ejercicios completados del workbook.
                        </li>
                        <li data-id="element-113">
                          Prueba de haber aplicado las estrategias, reflexiones
                          o ejercicios propuestos dentro del programa.
                        </li>
                        <li data-id="element-114">
                          Evidencia de que seguiste el contenido de forma activa
                          y no solo solicitaste el reembolso sin haberlo
                          utilizado.
                        </li>
                      </ul>
                    </li>
                    <li data-id="element-115">
                      Las solicitudes realizadas antes de los{' '}
                      <strong className="font-semibold text-deep-black" data-id="element-116">
                        14 días
                      </strong>{' '}
                      desde la compra no serán aceptadas, ya que consideramos
                      necesario un tiempo mínimo para consumir, aplicar e
                      integrar el material.
                    </li>
                  </ul>
                </div>

                <div data-id="element-117">
                  <h4 className="font-semibold text-deep-black mb-2" data-id="element-118">
                    Exclusiones
                  </h4>
                  <p data-id="element-119">No se otorgarán reembolsos en los siguientes casos:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-120">
                    <li data-id="element-121">
                      Compras de productos digitales marcados como venta final.
                    </li>
                    <li data-id="element-122">
                      Promociones, descuentos especiales, bundles, packs o
                      compras realizadas durante ofertas limitadas.
                    </li>
                    <li data-id="element-123">
                      Clientes que ya hayan solicitado previamente un reembolso
                      por el mismo producto.
                    </li>
                    <li data-id="element-124">
                      Casos donde no se presente prueba suficiente de haber
                      trabajado y aplicado el material.
                    </li>
                    <li data-id="element-125">
                      Solicitudes realizadas fuera del plazo de 30 días corridos
                      desde la compra.
                    </li>
                  </ul>
                  <p className="mt-3" data-id="element-126">
                    Debido a la naturaleza digital del producto, una vez
                    aprobado el reembolso, el acceso al eBook, meditaciones,
                    ejercicios, bonos y cualquier otro contenido relacionado
                    será revocado.
                  </p>
                </div>

                <div data-id="element-127">
                  <h4 className="font-semibold text-deep-black mb-2" data-id="element-128">
                    Proceso para Solicitar un Reembolso
                  </h4>
                  <p data-id="element-129">
                    Para solicitar un reembolso, deberás contactar a nuestro
                    equipo de soporte dentro del plazo correspondiente
                    escribiendo a:{' '}
                    <a href="mailto:adonisclubstore@gmail.com" className="text-bordeaux font-semibold underline underline-offset-2" data-id="element-130">
                      adonisclubstore@gmail.com
                    </a>
                  </p>
                  <p className="mt-3" data-id="element-131">Tu solicitud deberá incluir:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-132">
                    <li data-id="element-133">Nombre completo.</li>
                    <li data-id="element-134">Email utilizado en la compra.</li>
                    <li data-id="element-135">Fecha de compra.</li>
                    <li data-id="element-136">Motivo de la solicitud.</li>
                    <li data-id="element-137">
                      Prueba de haber completado y aplicado el material, según
                      lo explicado anteriormente.
                    </li>
                  </ul>
                  <p className="mt-3" data-id="element-138">
                    Una vez recibida la solicitud, nuestro equipo revisará el
                    caso y responderá dentro de un plazo razonable.
                  </p>
                  <p className="mt-3" data-id="element-139">
                    Si el reembolso es aprobado, el dinero será devuelto al
                    método de pago original dentro de un plazo estimado de{' '}
                    <strong className="font-semibold text-deep-black" data-id="element-140">
                      5 a 10 días hábiles
                    </strong>
                    , dependiendo de la entidad bancaria o plataforma de pago
                    utilizada.
                  </p>
                </div>

                <div data-id="element-141">
                  <h4 className="font-semibold text-deep-black mb-2" data-id="element-142">
                    Nuestro Compromiso
                  </h4>
                  <p data-id="element-143">
                    Esta política está diseñada para proteger tanto a nuestras
                    clientas como la integridad de nuestro contenido digital.
                  </p>
                  <p className="mt-3" data-id="element-144">
                    Queremos que tengas una experiencia clara, segura y positiva
                    con Diosa Letal. Si realizaste el trabajo, aplicaste el
                    material y aún así considerás que el producto no cumplió con
                    lo prometido, vamos a revisar tu caso con seriedad y
                    compromiso.
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}